import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/commons/generic.service';
import { environment } from 'environments/environment';
import { RelatorioAnalitico } from 'app/model/relatorioAnalitico.dto';
import { Page } from 'app/model/Paginacao/Page';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelatorioRecadastramentoService extends GenericService {

  private path = 'api/v1/recadastramento/relatorio-admin';

  constructor(http: HttpClient) {
    super(http);
  }

  anosCampanha() {
    return this.getMethod(this.path + `/anos-campanha`);
  }

  periodoCampanho(ano) {
    return this.getMethod(this.path + `/ano/${ano}/periodo`);
  }

  dadosRelatorioSintetico(data) {
    return this.getMethod(this.path + '/sintetico', data);
  }

  getServidor(dadosServidor): Observable<any> {
    const começaComNúmero = /^\d/.test(dadosServidor);
    let nome = '';
    let matricula = 0;

    if (começaComNúmero) {
      matricula = dadosServidor;
    } else {
      nome = dadosServidor;
    }
    return this.http.get<any>(`${this.path}/servidor?nome=${nome}&matricula=${matricula}&pagina=0&itens=10`);
  }
  getRealtorioAnalitico(params: {
    dataInicio: string;
    dataFim: string;
    matricula: number;
    status: number;
    pagina: number;
    itens: number;
    ano: number;
  }): Observable<RelatorioAnalitico> {

    const { dataInicio, dataFim, matricula, status, pagina, itens, ano } = params;

    const queryParams = new HttpParams()
      .set('dataInicio', dataInicio)
      .set('dataFim', dataFim)
      .set('matricula', matricula.toString())
      .set('status', status.toString())
      .set('pagina', pagina.toString())
      .set('itens', itens.toString())
      .set('ano', ano.toString());

    return this.http.get<RelatorioAnalitico>(`${environment.url}${this.path}/analitico`, { params: queryParams });
  }

  dadosRelatorioAnalitico(data) {
    return this.getMethod(`${this.path}/analitico`, data)
  }

  uploadComprovanteEstadoCivil(formData: FormData) {
    return this.patchMethodFile(this.path + '/estado_civil', formData);
  }

  uploadComprovanteConjuge(formData: FormData) {
    return this.patchMethodFile(this.path + '/conjuge', formData);
  }

  dadosRelatorioPlanoSaude(data) {
    return this.getMethod('api/v1/recadastramento/relatorio-plano-saude/gerar-relatorio', data);
  }

}